module.exports = __webpack_public_path__ + "static/media/vertex-5002x-m.ac1433a6.jpg";